import { RefObject, useEffect, useState } from "react";

export const useIsVisible = (ref: RefObject<Element>) => {
    const [isOnScreen, setIsOnScreen] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) {
            return;
        }

        const observer = new IntersectionObserver(([entry]) =>
            setIsOnScreen(entry.isIntersecting)
        );
        observer.observe(node);

        return () => observer.disconnect();
    });
    // Re-run when the parent re-renders so a ref that materializes after mount is observed.

    return isOnScreen;
};
